import { Component, Inject,ViewChild, PLATFORM_ID } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { LoginService } from './service/Login/login.service';
import { environment } from '../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { Router, NavigationEnd  } from '@angular/router';
import { SharedService } from './shared.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'SurplusTek';

    // title = environment.title;
    token: String = "";
    name: any;
    user_type: any;
    user_id: any;
    login_status = 0;
    Loader:boolean = false;
    authusername: any = '';
    side_bartoggle :boolean = false;

    constructor(
        private sharedService: SharedService,
        private http: HttpClient,
        private loginService: LoginService,
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(DOCUMENT) private document: Document,
        public router: Router,
        private toaster: ToastrService,

    ) {

        const localStorage = document.defaultView?.localStorage;

        if (localStorage) {
            let obj = {
                doc_id: localStorage.getItem('doc_id'),
                batch_no: localStorage.getItem('batch_no')
            }
        }


    }


    ngOnInit() {


        this.login_status = 0;
        this.Loader = true;
        if (isPlatformBrowser(this.platformId)) {

            if (localStorage.getItem('token') != null) {
                this.loginService.GetStatus().subscribe({
                    next: (res) => {
                        this.Loader = false;
                        if (res && res.data) {
                            this.name = res.data.name;
                            this.user_type = res.data.user_type;
                            this.user_id = res.data.user_id;
                            this.authusername = res.data.name;
                            this.sharedService.updateName(this.name);
                            this.login_status = 1;
                            this.side_bartoggle = true;

                        }

                    }, error: (err) => {
                        this.Loader = false;
                        if (err.status === 422 && err.error.errors) {
                            const validationErrors = err.error.errors;

                            Object.keys(validationErrors).forEach(key => {
                                const errorMessages = validationErrors[key];
                                this.toaster.error(errorMessages[0]);
                                return
                            });
                        } else {
                            this.toaster.error('An error occurred in User Get Status Request');
                        }
                    }
                });

            }else{
                this.router.navigate(["/login"]);
            }
        }
        this.Loader = false;

    }


    getIPAddress() {

        return this.http.get("https://api.ipify.org/?format=json");

    }

    getBrowserName() {

        if (isPlatformBrowser(this.platformId) && typeof navigator !== 'undefined') {
            const agent = navigator.userAgent.toLowerCase();

            switch (true) {
                case agent.indexOf('edg') > -1:

                    return 'edge';
                case agent.indexOf('opr') > -1:

                    return 'opera';
                case agent.indexOf('chrome') > -1:

                    return 'chrome';
                case agent.indexOf('trident') > -1:
                    return 'ie';
                case agent.indexOf('firefox') > -1:
                    return 'firefox';
                case agent.indexOf('safari') > -1:
                    return 'safari';
                default:
                    return 'other';
            }
        } else {
            return 'environment not browser supported';
        }

    }

    getBrowserVersion() {

        if (typeof navigator !== 'undefined' && navigator.userAgent) {

            var userAgent = navigator.userAgent, tem,

                matchTest = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

            if (/trident/i.test(matchTest[1])) {

                tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];

                return 'IE ' + (tem[1] || '');

            }

            if (matchTest[1] === 'Chrome') {

                tem = userAgent.match(/\b(OPR|Edg)\/(\d+)/);

                if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');

            }

            matchTest = matchTest[2] ? [matchTest[1], matchTest[2]] : [navigator.appName, navigator.appVersion, '-?'];

            if ((tem = userAgent.match(/version\/(\d+)/i)) != null) matchTest.splice(1, 1, tem[1]);

            return matchTest.join(' ');

        } else {
            return 'environment not supported';
        }

    }

    getOsName(): string {
        if (typeof navigator !== 'undefined' && navigator.userAgent) {

            const platform = navigator.userAgent.toLowerCase();

            if (platform.indexOf('win') !== -1) {
                return 'Windows';
            } else if (platform.indexOf('mac') !== -1) {
                return 'MacOS';
            } else if (platform.indexOf('linux') !== -1) {
                return 'Linux';
            } else if (platform.indexOf('iphone') !== -1 || platform.indexOf('ipad') !== -1) {
                return 'iOS';
            } else if (platform.indexOf('android') !== -1) {
                return 'Android';
            } else {
                return 'Unknown';
            }
        } else {
            return 'environment not OS supported';
        }

    }

    ngAfterViewInit() {

        if (isPlatformBrowser(this.platformId)) {

            setTimeout(() => {
                this.getIPAddress().subscribe((res: any) => {
                    localStorage.setItem('getip', res.ip);
                });

                var OSName = this.getOsName();

                // if (navigator.appVersion.indexOf("Win")!=-1) OSName="Windows";
                // if (navigator.appVersion.indexOf("Mac")!=-1) OSName="MacOS";
                // if (navigator.appVersion.indexOf("X11")!=-1) OSName="UNIX";
                // if (navigator.appVersion.indexOf("Linux")!=-1) OSName="Linux";

                localStorage.setItem('getbrowser', this.getBrowserName());
                localStorage.setItem('getostype', OSName);
                localStorage.setItem('getbrowser_version', this.getBrowserVersion());
            }, 1000)
        }


    }


    sidebartoggle(toggle:boolean){
    //     // alert(toggle);
        this.side_bartoggle = toggle;
    }

}


